module.exports = __webpack_public_path__ + "img/2.856f38ff.jpg";